import React from "react";
import "./Home.css";
const Home = () => {
  return (
    <div className="home">
      <h3 className="board-setup-title bg-dark text-white lh-base mb-1">
        Kurt configurator
      </h3>
    </div>
  );
};

export default Home;
